"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Button } from "flowbite-react";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';


const Intro = () => {
    return (
        <div>
            <section className=" bg-white py-10 md:py-20 lg:py-24">
                <div className="max-w-screen-xl mx-5 lg:mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 items-start justify-between text-center mb-6 md:mb-10">
                        <div>
                            <a href="/gallery/"><img src="/images/fm_gallery1.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/fm_gallery3.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/fm_gallery2.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/fm_gallery4a.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/fm_gallery5.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/fm_gallery6.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/fm_gallery7.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-3 md:gap-6 items-start justify-between">
                        <p>BOE offers a plethora of cutting-edge services such as content creation, film production, product shoots, line production, casting, celebrity tie-ups and post production. We provide a wholesome experience of everything under the BIG umbrella of production.</p>
                        <p>In this journey so far we have produced feature film, ad films, multiple TV series, web series, corporate videos, 360 degree videos, digital films, short films and social media content.</p>
                        <p>We value every brand that gives us the golden opportunity to be their content creators.</p>
                    </div>                    
                </div>
            </section>
        </div>
    );
};

export default Intro;